<app-ehe-header [auth]="true"></app-ehe-header>
<section class="messaging-wrapper general-wrapper">
	<div class="container">
		<div class="row pt-30">
			<div class="col-md-2 text-18 g-left d-none d-lg-block">
				<div class="aside-module">
					<div class="module-content">
						<ul>
							<li>
								<button
									class="button button-medium"
									mat-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="redirectToCompose()">
									<span [translate]="'messaging.navigation.compose-button'">COMPOSE</span>
								</button>
							</li>
							<li>
								<a
									class="d-block clearfix float-none"
									routerLinkActive="active"
									[routerLink]="['/messaging/mailbox/inbox']"
									appEheAnalytics
									[data]="{
										pageUrl: '/messaging/mailbox/inbox',
										redirectedTo: '/messaging/mailbox/inbox',
										componentName: 'Messaging',
										id: 'Inbox',
										placement: 'messaging'
									}">
									<span class="float-left" [translate]="'messaging.left-nav.inbox'">Inbox</span>
									<span class="float-right"
										>{{
											messagingService.getCurrentMessageCount().getValue().inbox > 0
												? messagingService.getCurrentMessageCount().getValue().inbox
												: ''
										}}
									</span>
								</a>
							</li>
							<li>
								<a
									class="d-block clearfix float-none"
									routerLinkActive="active"
									[routerLink]="['/messaging/mailbox/sent']"
									appEheAnalytics
									[data]="{
										pageUrl: '/messaging/mailbox/inbox',
										redirectedTo: '/messaging/mailbox/sent',
										componentName: 'Messaging',
										id: 'Sent',
										placement: 'messaging'
									}">
									<span class="float-left" [translate]="'messaging.left-nav.sent'">Sent</span>
									<span class="float-right">{{
										messagingService.getCurrentMessageCount().getValue().sent > 0
											? messagingService.getCurrentMessageCount().getValue().sent
											: ''
									}}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="col-md-10 g-right">
				<div class="left-outline">
					<router-outlet></router-outlet>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-spinner></app-ehe-spinner>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
